import Select, { components } from 'react-select'

const SelectAction = ({ label, value, callback, style, opt }) => {
  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>Pipeline not found</span>
      </components.NoOptionsMessage>
    )
  }
  return (
    <>
      <label>{label}</label>
      <Select
        options={opt}
        styles={style}
        placeholder={'Select...'}
        menuPlacement="auto"
        isSearchable={true}
        value={opt.find((f) => f.value === value) || ''}
        onChange={callback}
        components={{ NoOptionsMessage }}
      />
    </>
  )
}

export default SelectAction
